import type {
  RetryConfigDetail,
  RetryConfigListRow,
  RetryConfigPagination,
} from 'src/interfaces/retryConfig'
import type { State } from '../reducers/types'

/**
 * Returns the stored array by reference. Never build a new array or object literal in a
 * selector — every consuming `useSelector` would re-render on each dispatch. Filtering and
 * sorting belong in the component under `useMemo`.
 */
export const getRetryConfigs = (state: State): RetryConfigListRow[] => {
  return state.retryConfig.configs
}

export const getRetryConfigsPagination = (state: State): RetryConfigPagination => {
  return state.retryConfig.pagination
}

export const getRetryConfigsLoading = (state: State): boolean => {
  return state.retryConfig.listLoading
}

export const getRetryConfigsError = (state: State): string | null => {
  return state.retryConfig.listError
}

export const getRetryConfigDetail = (state: State): RetryConfigDetail => {
  return state.retryConfig.detail
}

export const getRetryConfigDetailLoading = (state: State): boolean => {
  return state.retryConfig.detailLoading
}

export const getRetryConfigDetailError = (state: State): string | null => {
  return state.retryConfig.detailError
}

export const getRetryConfigSaving = (state: State): boolean => {
  return state.retryConfig.saving
}

export const getReschedulingJobId = (state: State): string | null => {
  return state.retryConfig.reschedulingJobId
}
